import translations from '../../../translations';
import FormGroup from '../../generic/FormGroup';
import type { DispatchFlowConfiguration } from './reducer';

interface Props {
    stateExpirationLength: number;
    idleStateExpirationLength: number;
    stateLockedByUserModification: boolean;
    dispatchFlowConfiguration: DispatchFlowConfiguration;
}

const State = ({
    stateExpirationLength,
    idleStateExpirationLength,
    stateLockedByUserModification,
    dispatchFlowConfiguration,
}: Props) => {
    const safeNumber = (maybeNumber: number | undefined) => {
        if (typeof maybeNumber === 'number' && !Number.isNaN(maybeNumber)) {
            return maybeNumber;
        }
        return 0;
    };

    return (
        <>
            <h2>State</h2>
            <FormGroup
                htmlFor="properties-state"
                label={translations.FLOW_PROPERTIES_states_in_flight}
            >
                <input
                    id="properties-state"
                    className="form-control-dynamic form-control"
                    type="number"
                    min={0}
                    max={180}
                    placeholder="Never"
                    value={stateExpirationLength === 0 ? undefined : stateExpirationLength}
                    onChange={({ target }) => {
                        dispatchFlowConfiguration({
                            type: 'updateStateExpirationLength',
                            payload: {
                                length: safeNumber(target.valueAsNumber),
                            },
                        });
                    }}
                />
            </FormGroup>
            <FormGroup
                htmlFor="properties-inactive-state"
                label={translations.FLOW_PROPERTIES_states_inactivity}
            >
                <input
                    id="properties-inactive-state"
                    className="form-control-dynamic form-control"
                    type="number"
                    min={0}
                    max={180}
                    placeholder="Never"
                    value={idleStateExpirationLength === 0 ? undefined : idleStateExpirationLength}
                    onChange={({ target }) => {
                        dispatchFlowConfiguration({
                            type: 'updateIdleStateExpirationLength',
                            payload: {
                                length: safeNumber(target.valueAsNumber),
                            },
                        });
                    }}
                />
            </FormGroup>
            <label htmlFor="properties-lock-state">
                <input
                    id="properties-lock-state"
                    className="checkbox-margin-left"
                    type="checkbox"
                    checked={stateLockedByUserModification}
                    onChange={({ target }) => {
                        dispatchFlowConfiguration({
                            type: 'updateStateLockedByUserModification',
                            payload: { isEnabled: target.checked },
                        });
                    }}
                />
                {translations.FLOW_PROPERTIES_states_lock}
            </label>
        </>
    );
};

export default State;
